import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error Untyped import
import useMediaQuery from '../../../hooks/useMediaQuery';
import { device } from '../../../constants/StyledComponentConstants';
import UIFlex from 'UIComponents/layout/UIFlex';
import RetakeExamButton from './RetakeExamButton';
import EmailBreakdownButton from './EmailBreakdownButton';
import { Fragment } from 'react';
import { FormattedMessage } from '../../../components/I18n';
import { useMostRecentExamAttempt } from '../../exams';
import { useFullTrack, useTrackPendingPracticalExercises } from '../../tracks';
import { HasParentPlaylist, NextPlaylistContent } from '../../playlistContent';
import { getTrackRecommendationsUrl } from '../../../utils/RoutingUtils';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import styled from '../../../utils/Styling';
import { useLocation } from 'react-router-dom';
const StyledRouterButton = styled(UIRouterButton).withConfig({
  displayName: "ExamFinishedSecondaryButtons__StyledRouterButton",
  componentId: "sc-14o6taf-0"
})(["margin-top:0 !important;"]);

const ExamFinishedNextSteps = (_ref) => {
  let {
    to
  } = _ref,
      buttonProps = _objectWithoutPropertiesLoose(_ref, ["to"]);

  const location = useLocation();
  return /*#__PURE__*/_jsx(StyledRouterButton, Object.assign({
    "data-test-id": "exam-next-steps",
    to: Object.assign({}, location, {
      pathname: to
    }),
    use: to === '/' ? 'tertiary-light' : 'secondary'
  }, buttonProps, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.exams.finished.${to === '/' ? 'backToLearningTracks' : 'next'}`
    })
  }));
};

const ExamFinishedSecondaryButtons = ({
  retake,
  trackId
}) => {
  const {
    track
  } = useFullTrack(trackId);
  const {
    mostRecentExamAttempt
  } = useMostRecentExamAttempt(Number(trackId));
  const {
    pendingPracticalExercises
  } = useTrackPendingPracticalExercises(trackId.toString());
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  if (!mostRecentExamAttempt || !track || !pendingPracticalExercises) return null;
  const hasCertification = track.certification && mostRecentExamAttempt.passed && !pendingPracticalExercises.length;

  const nextSteps = className => /*#__PURE__*/_jsx(HasParentPlaylist, {
    fallback: /*#__PURE__*/_jsx(ExamFinishedNextSteps, {
      className: className,
      to: hasCertification ? getTrackRecommendationsUrl(track.id.toString()) : '/'
    }),
    children: /*#__PURE__*/_jsx(NextPlaylistContent, {
      render: ({
        url
      }) => /*#__PURE__*/_jsx(ExamFinishedNextSteps, {
        className: "m-left-3",
        to: url
      }),
      trackId: track.id
    })
  });

  if (isMobile) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        direction: "column",
        children: [retake && /*#__PURE__*/_jsx(RetakeExamButton, {
          trackId: trackId,
          use: mostRecentExamAttempt.passed ? 'tertiary-light' : 'tertiary',
          withTooltip: true
        }), nextSteps('m-top-3'), /*#__PURE__*/_jsx(EmailBreakdownButton, {
          className: "p-y-2 m-top-3",
          tooltipTitle: !mostRecentExamAttempt.finished && /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'learningCenter.exams.finished.breakdownUnavailable'
          }),
          trackId: trackId
        })]
      })
    });
  }

  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(EmailBreakdownButton, {
      tooltipTitle: !mostRecentExamAttempt.finished && /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'learningCenter.exams.finished.breakdownUnavailable'
      }),
      trackId: trackId
    }), /*#__PURE__*/_jsx(RetakeExamButton, {
      trackId: trackId,
      use: mostRecentExamAttempt.passed ? 'tertiary-light' : 'tertiary',
      withTooltip: true
    }), nextSteps('m-left-3')]
  });
};

export default ExamFinishedSecondaryButtons;